import { onMounted, ref } from 'vue'

export function useTenantLogo() {
  const hasTenantLogo = ref(false)

  onMounted(async () => {
    try {
      const logoResponse = await fetch('/assets/logo.png', { method: 'HEAD' })

      hasTenantLogo.value = logoResponse.ok
    } catch {
      hasTenantLogo.value = false
    }
  })

  return {
    hasTenantLogo,
  }
}
